'use client'
import MainMenu from '../components/MainMenu';
import Link from 'next/link';
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import HoverGif from '@/components/GifOnHoverAndScroll';
import TrustExpanding from '@/components/TrustExpanding';
import LogoCarousel from '@/components/LogoCarousel';
import 'swiper/css';
import 'swiper/css/pagination';
import { useRef } from 'react';
import { Swiper, SwiperSlide, } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';
import { Navigation } from 'swiper/modules';
import { ChevronRight } from 'lucide-react';

export default function Home() {
	const { phoneNumber, isCookieLoading } = usePhoneNumber();


	const swiperRef = useRef<SwiperType>();

	return (
		<main className="flex min-h-screen flex-col items-center justify-between overflow-hidden">
			<MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} scrollIndicatorEnabled={true} />
			<section className="text-start pt-10 pb-0 md:py-24 w-screen justify-start bg-gradient-to-t from-gradient-start to-white dark:from-purple-700 dark:to-dark-800">
				<div className='container grid md:grid-cols-2 my-20 items-center'>
					<div>
						<div className='text-4xl md:text-6xl font-semibold'>
							Шинжлэх ухаанчаар өөрийгөө <span className='text-purple-500 dark:text-purple-400'>бүтээх дижитал хөтөч.</span>
						</div>
						<div className='text-lg mt-10'>
							Өөрийгөө болон ажил мэргэжлээ цогцоор нь харж ирээдүйгээ бүтээ.
						</div>
						<div className='mt-10 grid grid-cols-1 md:flex md:space-x-4 space-y-4 md:space-y-0 justify-start text-career-dark-300'>
							<Link href="/test" className='w-full md:w-fit'>
								<button
									className="w-full md:w-fit rounded-lg text px-6 py-3 shadow  bg-purple-500  text-white  cursor-pointer"
								>
									Тест бөглөх
								</button>
							</Link>
							<Link href="/faq" className='w-full md:w-fit'>
								<button
									className="w-full md:w-fit rounded-lg text px-6 py-3 
							text-purple-500 bg-white shadow cursor-pointer"
								>
									Түгээмэл асуулт хариулт
								</button>
							</Link>
						</div>
					</div>
					<div className='justify-end hidden md:flex'>
						<Image
							src="/images/header.png"
							alt="Image 2"
							width={470}
							height={397}
							unoptimized={true}
						/>
					</div>
				</div>
			</section>

			<section className='bg-homepage-dark w-full dark:bg-dark-600'>
				<div className='my-24 container flex justify-center flex-col justify-items-center '>
					<div className='md:text-5xl text-3xl mx-auto max-w-[700px] font-semibold text-center'>Мэргэжлээ сонгоход хэрэгтэй бүхнийг <span className='text-purple-main dark:text-purple-400'>нэг дороос</span></div>

					<div className='container grid md:grid-cols-2 mt-8 md:mt-20 items-center'>
						<div className='justify-start'>
							<Image
								src="/images/mid.png"
								alt="Image 2"
								width={470}
								height={397}
								unoptimized={true}
							/>
						</div>
						<div className='mt-8 md:mt-0 space-y-6'>
							<div className='flex flex-row space-x-4'>
								<div><FontAwesomeIcon icon={faCheckCircle} width={24} height={24} className='text-career-green' /></div>
								<div className='flex flex-col'>
									<div className='text-career-dark-600 dark:text-white text-xl font-semibold'>Карьер тест</div>
									<div className='text-career-dark-500 dark:text-purple-50 text-lg'>Онцлогоо бүх талаас нь хар</div>
								</div>
							</div>
							<div className='flex flex-row space-x-4'>
								<div><FontAwesomeIcon icon={faCheckCircle} width={24} height={24} className='text-career-green' /></div>
								<div className='flex flex-col'>
									<div className='text-career-dark-600 dark:text-white text-xl font-semibold'>Тохирох ажил мэргэжлүүд</div>
									<div className='text-career-dark-500 dark:text-purple-50 text-lg'>Зан төлөв, сонирхол, чадвар, амьдралын зорилгодоо нийцэх ажил мэргэжлүүдийг олж мэдээрэй </div>
								</div>
							</div>
							<div className='flex flex-row space-x-4'>
								<div><FontAwesomeIcon icon={faCheckCircle} width={24} height={24} className='text-career-green' /></div>
								<div className='flex flex-col'>
									<div className='text-career-dark-600 dark:text-white text-xl font-semibold'>Мэдээлэл</div>
									<div className='text-career-dark-500 dark:text-purple-50 text-lg'>Мэргэжил, сургууль, ажлын байрны талаарх мэдээлэл болон контентууд</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>


			{/* <section className='py-24 flex justify-center flex-col justify-items-center  w-full'>
				<div className='md:text-5xl text-3xl mx-auto max-w-[700px] font-semibold text-center'>Вебийг ашиглах <span className='text-purple-main'>алхмууд</span></div>
				<div className='grid md:grid-cols-4 mt-8 md:mt-20 items-center justify-between container md:space-x-8 space-y-10 md:space-y-0'>
					<HoverGif 
						pngSrc="/images/todo.png" 
						gifSrc="/images/todo.gif" 
						alt="Sample image" 
						width={70} 
						height={70}
						header='Тест бөглөх'
						description='Зан төлөв, сонирхол, чадвар, амьдралын зорилгоо үнэлэх '
					/>
					<HoverGif 
						pngSrc="/images/search.png" 
						gifSrc="/images/search.gif" 
						alt="Sample image" 
						width={70} 
						height={70}
						header='Таньж мэдэх'
						description='Өөрийнхөө онцлогийг таньж мэдэх Тестийн хариугаа үзэж, өөрт тохирох ажил мэргэжлүүдтэй танилцах  '
					/>
					<HoverGif 
						pngSrc="/images/book.png" 
						gifSrc="/images/book.gif" 
						alt="Sample image" 
						width={70} 
						height={70}
						header='Судлах'
						description='Ажил мэргэжлийн ертөнцийг судлах ЭЕШ, сургууль, ажил мэргэжлүүдийн талаарх мэдээлэл, мэргэжилтнүүдтэй хийсэн ярилцлага үзэх.  '
					/>
					<HoverGif 
						pngSrc="/images/university.png" 
						gifSrc="/images/university.gif" 
						alt="Sample image" 
						width={70} 
						height={70}
						header='Мэргэжлээ сонго'
						description='Мэргэжлээ сонгоход туслах лекц, уулзалтуудад бүртгүүлэх.  '
					/>
				</div>
			</section> */}


			<section className='py-24 flex justify-center flex-col justify-items-center w-full dark:bg-dark-800'>
				<div className='md:text-5xl text-3xl mx-auto max-w-[700px] font-semibold text-center'>Вебийг ашиглах <span className='text-purple-main dark:text-purple-400'>алхмууд</span></div>
				<div className='mt-8 md:mt-20 max-w-[970px] mx-auto'>
					<div className='flex flex-col md:flex-row justify-between items-center md:space-x-20'>
						<div className='text-career-dark-500 dark:text-white px-4 md:px-0 text-center md:text-start max-w-[470px]'>
							<div className='text-xl md:text-2xl font-semibold'>Тестээ бөглөх</div>
							<div className='md:mt-3 md:text-lg font-semibold'>Зан төлөв, сонирхол, чадвар, амьдралын зорилгоо үнэлэх</div>
						</div>
						<div className='relative mt-6 md:mt-0 flex-grow-0 md:mx-0 mx-5'>
							<Image
								src="/images/1.png"
								alt={"Тест бөглөх"}
								width={380}
								height={285}
								unoptimized
								className="w-full md:w-[380px]"
							/>
							<Image
								src="/images/11.png"
								alt={"Тест бөглөх"}
								width={136}
								height={36}
								unoptimized
								className='absolute left-5 top-0 animate-hover-1'
							/>
							<Image
								src="/images/12.png"
								alt={"Тест бөглөх"}
								width={165}
								height={163}
								unoptimized
								className='absolute right-0 md:-right-20 md:-bottom-20 -bottom-10 animate-hover-2'
							/>
						</div>
					</div>


					<div className='flex flex-col md:flex-row justify-between items-center mt-20'>
						<div className='text-career-dark-500 dark:text-white max-w-[470px] px-4 md:px-0 text-center md:text-start flex-auto md:hidden'>
							<div className='text-xl md:text-2xl font-semibold'>Таньж мэдэх</div>
							<div className='md:mt-3 md:text-lg font-semibold'>Тестийн хариугаа үзэж, өөрт тохирох ажил мэргэжлүүдтэй танилцах</div>
						</div>
						<div className='relative mt-6 md:mt-0 flex-grow-0 md:mx-0 mx-5'>
							<Image
								src="/images/2.png"
								alt={"Тест бөглөх"}
								width={380}
								height={285}
								unoptimized
								className="w-full md:w-[380px]"
							/>
							<Image
								src="/images/21.png"
								alt={"Тест бөглөх"}
								width={278}
								height={56}
								unoptimized
								className='absolute left-0 -top-7 animate-hover-3'
							/>
							<Image
								src="/images/22.png"
								alt={"Тест бөглөх"}
								width={235}
								height={59}
								unoptimized
								className='absolute right-0 -bottom-3 animate-hover-4'
							/>
						</div>
						<div className='text-career-dark-500 dark:text-white max-w-[470px] px-4 md:px-0 text-center md:text-start flex-auto md:block hidden'>
							<div className='text-xl md:text-2xl font-semibold'>Таньж мэдэх</div>
							<div className='md:mt-3 md:text-lg font-semibold'>Тестийн хариугаа үзэж, өөрт тохирох ажил мэргэжлүүдтэй танилцах</div>
						</div>
					</div>


					<div className='flex flex-col md:flex-row justify-between items-center mt-20'>
						<div className='text-career-dark-500 dark:text-white px-4 md:px-0 text-center md:text-start max-w-[470px]'>
							<div className='text-xl md:text-2xl font-semibold'>Судлах</div>
							<div className='md:mt-3 md:text-lg font-semibold'>ЭЕШ, сургууль, ажил мэргэжлүүдийн талаарх мэдээлэл, мэргэжилтнүүдтэй хийсэн ярилцлага үзэх.</div>
						</div>
						<div className='relative mt-6 md:mt-0 flex-grow-0 md:mx-0 mx-5'>
							<Image
								src="/images/3.png"
								alt={"Судлах"}
								width={380}
								height={285}
								unoptimized
								className="w-full md:w-[380px]"
							/>
							<Image
								src="/images/31.png"
								alt={"Судлах"}
								width={220}
								height={48}
								unoptimized
								className='absolute right-0 md:-right-5 top-0 animate-hover-5'
							/>
							<Image
								src="/images/32.png"
								alt={"Судлах"}
								width={188}
								height={130}
								unoptimized
								className='absolute left-0 md:-left-16 -bottom-14 animate-hover-6'
							/>
						</div>
					</div>


					<div className='flex flex-col md:flex-row justify-between items-center mt-20'>
						<div className='text-career-dark-500 dark:text-white max-w-[470px] px-4 md:px-0 text-center md:text-start flex-auto md:hidden'>
							<div className='text-xl md:text-2xl font-semibold'>Оролцох</div>
							<div className='md:mt-3 md:text-lg font-semibold'>Мэргэжлээ сонгоход туслах лекц, уулзалтуудад бүртгүүлэх.</div>
						</div>
						<div className='relative mt-6 md:mt-0 flex-grow-0 md:mx-0 mx-5'>
							<Image
								src="/images/4.png"
								alt={"Оролцох"}
								width={380}
								height={285}
								unoptimized
								className="w-full md:w-[380px]"
							/>
							<Image
								src="/images/41.png"
								alt={"Оролцох"}
								width={349}
								height={53}
								unoptimized
								className='absolute -right-0 -bottom-5 animate-hover-7'
							/>
						</div>
						<div className='text-career-dark-500 dark:text-white max-w-[470px] px-4 md:px-0 text-center md:text-start flex-auto hidden md:block'>
							<div className='text-xl md:text-2xl font-semibold'>Оролцох</div>
							<div className='md:mt-3 md:text-lg font-semibold'>Мэргэжлээ сонгоход туслах лекц, уулзалтуудад бүртгүүлэх.</div>
						</div>
					</div>

				</div>
			</section>


			<section className='bg-homepage-dark w-full dark:bg-dark-600'>
				<section className='my-24 container flex justify-center flex-col justify-items-center '>
					<div className='md:text-5xl text-3xl mx-auto max-w-[700px] font-semibold text-center'>Бидэнд итгэх <span className='text-purple-main dark:text-purple-400'>шалтгаан</span></div>
					<div className='container grid md:grid-cols-2 mt-8 md:mt-20 md:gap-x-20'>
					<div className="justify-start relative max-w-[520px]">
						<Image
							src="/images/trust.png"
							alt="Image 2"
							width={470}
							height={397}
							className="relative z-10"
						/>
						<Image
							src="/images/dotted.png"
							alt="Image 2"
							width={122}
							height={122}
							className="absolute -bottom-[40px] -right-0 z-0 md:flex hidden"
						/>
					</div>
						<div className='mt-8 md:mt-0 space-y-6'>
							<TrustExpanding name={'Сэтгэл судлаачид хөгжүүлсэн'} >
								Асуултууд болон үр дүнг тооцох аргачлалыг бид өөрсдөө боловсруулсан бөгөөд монголын тэргүүлэх сэтгэл судлаачид болон гадаадын судлаачидтай хамтарсан.
							</TrustExpanding>
							<TrustExpanding name={'Монгол хүүхдүүдэд зориулсан'} >
								Асуултууд болон үр дүнг тооцох аргачлалыг бид өөрсдөө боловсруулсан бөгөөд монголын тэргүүлэх сэтгэл судлаачид болон гадаадын судлаачидтай хамтарсан.
							</TrustExpanding>
							<TrustExpanding name={'Өгөгдлийн аюулгүй байдал'} >
								Асуултууд болон үр дүнг тооцох аргачлалыг бид өөрсдөө боловсруулсан бөгөөд монголын тэргүүлэх сэтгэл судлаачид болон гадаадын судлаачидтай хамтарсан.
							</TrustExpanding>
						</div>
					</div>
				</section>
			</section>

			{/* <section className='py-28 w-full'>
				<LogoCarousel
					duration={20}
					pauseOnHover={true}
					blurBorders={false}
					blurBoderColor={'#fff'}
				>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
					<LogoCarousel.Slide>
						<Image src="/images/github.png" alt="any" className='w-24' width={300} height={80} />
					</LogoCarousel.Slide>
				</LogoCarousel>
			</section> */}


			<section className='bg-purple-bg dark:bg-purple-700 py-28 w-full'>
				<div className='container  h-[10em]'>
					<Swiper
						className="mySwiper"
						modules={[Navigation]}
						onBeforeInit={(swiper) => {
							swiperRef.current = swiper;
						}}
						breakpoints={{
							640: {
								slidesPerView: 1,
								spaceBetween: 20,
							},
							768: {
								slidesPerView: 2,
								spaceBetween: 30,
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 30, // Default settings
							},
						}}
					>
						<SwiperSlide>
							<div className=''>
								<div className='text-center'>Энэ тестийг ээжтэйгээ хамт бөгөллөө.Ээж минь намайг юунд сонирхолтой гэдгийг бага ч гэсэн мэдэж авсан. Өөрийгөө хөгжүүлэн юунд илүү сонирхолтой гэдгээ улам мэдэхийг хүсэж байна.</div>
								<div className='text-center font-semibold mt-4'>15 настай сурагч Ц</div>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className=''>
								<div className='text-center'>Ирээдүйн мэргэжил сонголтондоо жаахан эргэлзээд, өөр мэргэжлүүд санаагүй байсан, асуулга бөглөх явцдаа л өөр юунд сонирхолтой, ямар мэргэжил сонгох талаараа бодож чадлаа.</div>
								<div className='text-center font-semibold mt-4'>17 настай сурагч Н</div>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className=''>
								<div className='text-center'>Асуулга бөглөх хугацаанд өөртэйгөө ярилцсан мэт боллоо.</div>
								<div className='text-center font-semibold mt-4'>16 настай сурагч Э</div>
							</div>
						</SwiperSlide>

						<SwiperSlide>
							<div className=''>
								<div className='text-center'>Би өөрийгөө ямар хүн гэдгийг илүүтэй мэдэж авлаа.</div>
								<div className='text-center font-semibold mt-4'>14 настай сурагч У</div>
							</div>
						</SwiperSlide>


						<SwiperSlide>
							<div className=''>
								<div className='text-center'>Өөрийгөө таньж эхлэхэд тусаллаа</div>
								<div className='text-center font-semibold mt-4'>15 настай сурагч О</div>
							</div>
						</SwiperSlide>
					</Swiper>
				</div>
				<div className='text-center space-x-4 mt-8'>
					<button className='p-2 border border-career-dark-400 dark:border-white rounded-full' onClick={() => swiperRef.current?.slidePrev()}><FontAwesomeIcon icon={faArrowLeft} width={24} height={24} /></button>
					<button className='p-2 border border-career-dark-400 dark:border-white rounded-full' onClick={() => swiperRef.current?.slideNext()}><FontAwesomeIcon icon={faArrowRight} width={24} height={24} /></button>
				</div>
			</section>


			<section className='bg-homepage-dark dark:bg-dark-800 w-full'>
				<section className='my-24 container flex justify-center flex-col justify-items-center '>
					<div className='md:text-5xl text-3xl mx-auto max-w-[700px] font-semibold text-center'>Үнэгүй <span className='text-purple-main dark:text-purple-400'>тестүүд</span></div>
					<div className='container grid md:grid-cols-2 mt-8 md:mt-20 md:gap-x-12'>
						<Link href="/tipi" className=''>
						<div className='justify-center flex'>
							<button className='w-full bg-white dark:bg-dark-600 rounded-lg p-8'>
								<div className='text-lg font-semibold mb-4'>TIPI тест</div>
								<div>
								Бие хүний таван хүчин зүйлт загварт тулгуурласан 10 асуулттай тест.
								</div>
								<div className='flex flex-row justify-end mt-4 text-purple-500 dark:text-purple-400 font-semibold'>Бөглөх <ChevronRight size={25}/></div>
							</button>
						</div>
						</Link>
						<Link href="/mbti" className='mt-8 md:mt-0'>
						<div className='justify-center flex'>
							<button className='w-full bg-white dark:bg-dark-600  rounded-lg p-8'>
								<div className='text-lg font-semibold mb-4'>MBTI тест</div>
								<div>
								20 асуулт бөглөөд MBTI-ын 16 хэв шинжийн альд нь хамаарахаа мэдээрэй.
								</div>
								<div className='flex flex-row justify-end mt-4 text-purple-500 dark:text-purple-400 font-semibold'>Бөглөх <ChevronRight size={25}/></div>
							</button>
						</div>
						</Link>
					</div>
				</section>
			</section>



			<Footer />
		</main>
	)
}